/*
 * View for substitutions page
 */

define(["marionette", "modules/substitutions/template/substitutionsTemplate.html"], function (
  Marionette,
  SubstitutionsTemplate,
) {
  var SubstitutionsView = {};

  SubstitutionsView.substitutionsLayout = Marionette.Layout.extend({
    template: SubstitutionsTemplate,
    regions: {
      substitutionList: "#substitutionList",
      substitutionGroup: "#substitutionGroup",
      substitutionSearch: "#substitutionSearch",
    },
    triggers: {
      "click #addGroup": "add:group",
    },
  });

  return SubstitutionsView;
});
